/* eslint-disable max-lines */
import Modal from 'components/Modal';
import Table from 'components/Table';
import React from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';
import { useAsync } from 'react-use';
import { Group } from 'models/response';
import { useDocumentData } from 'hooks/useDocumentData';
import { useTableColumns } from 'hooks/useTableColumns';
import { DocumentTables } from 'components/DocumentTables/DocumentTables';

const Label = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  margin-bottom: 10px;
`;

const DocumentHistory = () => {
  const t = utils.intl.useTranslator();
  const {
    tableRows,
    historyRows,
    selectedDocument,
    setSelectedDocument,
    selectedGroup,
    setSelectedGroup,
    tasks,
    fetchData,
    activeDocument,
  } = useDocumentData();

  const { tableColumns, historyColumns } = useTableColumns();

  useAsync(async () => {
    await fetchData();
  }, []);

  const handleSelection = (item: any[]) => {
    setSelectedDocument(item.length ? item[0] : null);
    if (!item.length) setSelectedGroup(null);
  };

  const handleGroupSelection = (item: Group[]) => {
    setSelectedGroup(item?.length ? item[0] : null);
  };

  return (
    <>
      <Modal.Header title={t('document-history-header')} subtitle={t('document-history-subtitle')} />
      <Modal.Content>
        <Label>{t('document-history-label')}</Label>
        <Table
          id="document-history-table"
          sortBy={[{ id: 'dateAndTime', desc: true }]}
          columns={tableColumns}
          rows={tableRows}
          hasPagination
          hasSort
          hasFilter
          hasToolbar
          hasSelection
          onSelection={handleSelection}
        />

        <DocumentTables
          tasks={tasks}
          selectedDocument={selectedDocument}
          selectedGroup={selectedGroup}
          onGroupSelection={handleGroupSelection}
        />

        {historyRows !== null && (
          <>
            <Label>
              {activeDocument?.channel === 1
                ? t('mail-history')
                : activeDocument?.channel === 3
                ? t('pdf-history')
                : t('disk-history')}
            </Label>
            <Table
              id="document-history-table"
              sortBy={[{ id: 'insDate', desc: true }]}
              columns={historyColumns}
              rows={historyRows}
              hasPagination
              hasSort
              hasFilter
              hasToolbar
              specialColumns={{}}
            />
          </>
        )}
      </Modal.Content>

      <Modal.Footer withCloseButton closeButtonText={t('close-history')} withConfirmButton={false} />
    </>
  );
};

export default DocumentHistory;
